export default __webpack_public_path__ + "static/media/three.387553c8.jpeg";